import { Task } from '@/core/entity';
import { ITaskGateway, TaskInput } from '../interface/task';
import { PresenterFunc } from '../interface';
import { Fragment, UpdaterFunc } from '../interface/common';

export class TaskService {
  constructor(
    private readonly taskGateway: ITaskGateway,
  ) { }

  public async assignTask(
    taskId: string,
    userId: string,
    presenter: PresenterFunc<Task | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.taskGateway.assignTask(taskId, userId, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async newTasks(
    country: string,
    date: string,
    presenter: PresenterFunc<Task[] | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.taskGateway.newTasks(country, date, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async splitTask(
    taskId: string,
    entries: string[],
    presenter: PresenterFunc<Task | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.taskGateway.splitTask(taskId, entries, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }

  public async updateTask(
    taskId: string,
    input: TaskInput,
    presenter: PresenterFunc<Task | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const result = await this.taskGateway.updateTask(taskId, input, fragment, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
